<script setup lang="ts">

import { useRoute } from "vue-router";
import { currency } from "@library/Utilities";
import { useCarbucksApi } from "@app/Carbucks";
import { TransactionsViewModel } from "..";
import { useBackButton } from "@app/Components/Utilities";
import { TransactionRows } from "../Components";

useBackButton();

const route = useRoute();

const api = useCarbucksApi();
const category = getCategory();
const dto = await api.getCashbackTransactions( category  );
const model = new TransactionsViewModel( dto!, category );

/**
 * Gets the category name or null for all transactions
 */
function getCategory()
{
    const category = route.params.transactionType as string;
    if( category == null || category == '' ) return undefined;
    if( category == 'fuel' ) return 'Fuel';
    return category;
}

</script>

<template>

    <div class="pb-24 w-full h-full overflow-y-auto tracking-wider
                bg-gradient-to-b from-gray-900 via-gray-850 to-gray-900">
    
        <!-- HEADER -->
        <div class="p-6 text-center">
            <h2 v-if="model.transactionType == undefined" 
                class="text-xl 3xl:text-2xl tracking-wider flex gap-2 justify-center items-center">
                Transaction History
            </h2>
            <h2 v-else class="text-xl 3xl:text-2xl tracking-wider flex gap-2 justify-center items-center">
                <span class="capitalize">{{ model.transactionType }} </span>
                <span>Transactions</span>
            </h2>

        </div>  
       
        <!-- SUMMARY -->
        <div class="flex flex-col w-full">

            <div class="flex flex-col items-center w-full p-3 lg:p-4 gap-3 lg:gap-4 !pt-0">

                <div class="flex flex-col items-center w-full mb-4 lg:mb-6">
                    <h1 class="text-xs lg:text-base">Total cashback</h1>
                    <h2 class="glow mt-3 -mb-4 text-4xl lg:text-5xl text-secondary-500 dark:text-secondary-300 flex items-center">
                        {{ currency( model.totalCashbackAmount ) }}
                    </h2>
                </div>

                <div class="grid grid-cols-2 w-full">
                    <div class="py-1 lg:py-2 pl-2 pr-5 lg:pl-3 text-right">
                        <div class="flex items-center justify-center gap-2"> 
                            <Icon name="spend" class="text-4xl opacity-60"/>
                            <div>
                                <h1 class="text-xs lg:text-sm font-bold">Total Spend</h1>
                                <h2 class="text-lg lg:text-lg text-secondary-500 leading-tight">
                                    {{ currency(  model.totalPurchaseAmount ) }}
                                </h2>
                            </div>
                        </div>
                    </div> 
                
                    <div class="py-1 lg:py-2 pl-5 pr-2 lg:pr-3 text-right">
                        <div class="flex items-center justify-center gap-2">
                            <Icon name="champagne" class="text-3xl opacity-60"/>
                            <div>
                                <h1 class="text-xs lg:text-sm font-bold"># Rewards</h1>
                                <h2 class="text-lg lg:text-lg text-amber-500 dark:text-amber-400 leading-tight">
                                    {{ model.filteredTransactions.length }}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <!-- TRANSACTIONS -->
            <div class="w-full h-max
                        bg-gradient-to-b from-gray-850 to-transparent">

                <TransactionRows :transactions="model.filteredTransactions" />

            </div>

        </div>

    </div>

</template>
